import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import "./selectField.scss";

const SelectField = (props: any) => {
  return (
    <>
      <Select
        id="simple-select"
        className={
          "combo-box autocomplete " +
          (props?.disabled
            ? "disabled-dropdown"
            : props?.value === "Select"
            ? "place-holder"
            : "")
        }
        fullWidth
        disabled={props?.disabled}
        renderValue={(selected) => {
          if (!props?.value) {
            return <em>Placeholder</em>;
          }
          return (
            props.options?.find((item: any) => item?.value === props?.value)
              ?.label ||
            props?.placeHolder ||
            "Select"
          );
        }}
        name={props?.name}
        value={props?.value || ""}
        onChange={props?.onChange}
      >
        {props?.options?.map((name: any, index: any) => (
          <MenuItem
            key={name?.value}
            value={name?.value}
            className={
              props?.options?.length - 1 === index ? "" : "drop-down-border"
            }
            style={{ margin: "3px 10px 5px 10px", fontSize: "14px" }}
          >
            {name?.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default SelectField;
